import Vue from "vue";

export const EntitiesListPage = () =>
  import(/* webpackChunkName: "entities-module" */ "@/views/entities/List.vue");
export const EntitiesConfigurationPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/configurations/Layout.vue"
  );
export const EntitiesConfigurationGroupsPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/configurations/EntityGroups.vue"
  );
export const EntitiesConfigurationTypesPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/configurations/EntityTypes.vue"
  );
export const EntitiesConfigurationSectorsPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/configurations/EntitySectors.vue"
  );
export const EntityDetailSharedPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/details/Shared.vue"
  );
export const EntityDetailDashboardPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/details/Dashboard.vue"
  );
export const EntityDetailDocumentsPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/details/Documents.vue"
  );
export const EntityDetailEditPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/details/Edit.vue"
  );
export const EntityDetailUsersPage = () =>
  import(
    /* webpackChunkName: "entities-module" */ "@/views/entities/details/Users.vue"
  );

export function registerEntitiesModule(r: any): any {
  /* Side Menus Components */

  Vue.component("DetailEntitySideMenuComponent", () =>
    import(
      /* webpackChunkName: "entities-module" */ "@/views/entities/side-menus/DetailEntity.vue"
    )
  );

  Vue.component("CreateEntitySideMenuComponent", () =>
    import(
      /* webpackChunkName: "entities-module" */ "@/views/entities/side-menus/CreateEntity.vue"
    )
  );
  if (r.length > 0 && r[0].children) {
    r[0].children = r[0].children.concat(
      {
        path: "/entities/configurations",
        component: EntitiesConfigurationPage,
        children: [
          {
            path: "",
            redirect: "types"
          },
          {
            path: "types",
            component: EntitiesConfigurationTypesPage
          },
          {
            path: "sectors",
            component: EntitiesConfigurationSectorsPage
          },
          {
            path: "groups",
            component: EntitiesConfigurationGroupsPage
          }
        ]
      },
      {
        path: "entities",
        component: EntitiesListPage
      },
      {
        path: "entity/:id",
        component: EntityDetailSharedPage,
        children: [
          {
            path: "",
            redirect: "dashboard"
          },
          {
            path: "edit",
            component: EntityDetailEditPage
          },
          {
            path: "dashboard",
            component: EntityDetailDashboardPage
          },
          {
            path: "users",
            component: EntityDetailUsersPage
          },
          {
            path: "documents",
            component: EntityDetailDocumentsPage
          }
        ]
      }
    );
  }
  return r;
}
